import {
    SignupBackgroundLayout,
    TwcOverlayTemplate
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    CreateAWorkspaceHeading,
    CreateAWorkspaceText,
    Headings,
    SubHeading,
    WorkspacesAreWhereText
} from "../../components";

export const NewUser = () => {
    const twcSignupOverlayEnrolled = checkFeatureFlagGate(
        featureFlags.cfind5480TwcSignupOverlay
    );

    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    const content = (
        <>
            {team26VisualUpdates ? (
                <Headings
                    main={<CreateAWorkspaceText />}
                    sub={<WorkspacesAreWhereText />}
                />
            ) : (
                <>
                    <CreateAWorkspaceHeading />
                    <SubHeading>
                        <WorkspacesAreWhereText />
                    </SubHeading>
                </>
            )}
            <SiteActivation />
        </>
    );

    if (twcSignupOverlayEnrolled) {
        return <TwcOverlayTemplate size="sm">{content}</TwcOverlayTemplate>;
    }

    return (
        <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
            {content}
        </SignupBackgroundLayout>
    );
};
